// extracted by mini-css-extract-plugin
export default {"brandPromo":"cE-z","carousel":"dE-z"};